import SatelliteOverviewPage from "./SatelliteOverviewPage";

export default SatelliteOverviewPage;